module.exports = __webpack_public_path__ + "img/clock.277b4799.svg";